export default __webpack_public_path__ + "static/media/p5-9.a21e458c.png";